import i18n from 'i18next';
import { reactI18nextModule } from 'react-i18next';

import common_et from '../translations/et/common.json';
import public_et from '../translations/et/public.json';
import private_user_et from '../translations/et/private_user.json';
import private_common_et from '../translations/et/private_common.json';

import common_en from '../translations/en/common.json';
import public_en from '../translations/en/public.json';
import private_user_en from '../translations/en/private_user.json';
import private_common_en from '../translations/en/private_common.json';

const initI18n = () => {
  i18n
    .use(reactI18nextModule)
    .init({
      lng: 'et',
      fallbackLng: ['en'],
      ns: ['common', 'public', 'user'],
      resources: {
        en: {
          translation: {},
          "public": public_en,
          "my": private_user_en,
          "private": private_common_en,
          "common": common_en
        },
        et: {
          translation: {},
          "public": public_et,
          "my": private_user_et,
          "private": private_common_et,
          "common": common_et
        }
      },
      interpolation: {
        escapeValue: false
      }
    });
};

export default initI18n;



// WEBPACK FOOTER //
// ./src/conf/i18n.conf.js